/**
* jQuery scroroller Plugin 1.0
*
* http://www.tinywall.net/
* 
* Developers: Arun David, Boobalan
* Copyright (c) 2014 
*/


jQuery(document).ready(function() {
    jQuery(window).on("load",function(){
        jQuery(document).scrollzipInit();
        jQuery(document).rollerInit();
    });
    jQuery(window).on("load scroll resize", function(){
        jQuery('.numscroller').scrollzip({
            showFunction    :   function() {
                                    numberRoller(jQuery(this).attr('data-slno'));
                                },
            wholeVisible    :     false,
        });
    });
    jQuery.fn.scrollzipInit=function(){
        jQuery('body').prepend("<div style='position:fixed;top:0px;left:0px;width:0;height:0;' id='scrollzipPoint'></div>" );
    };
    jQuery.fn.rollerInit=function(){
        var i=0;
        jQuery('.numscroller').each(function() {
            i++;
           jQuery(this).attr('data-slno',i); 
           jQuery(this).addClass("roller-title-number-"+i);
        });        
    };
    jQuery.fn.scrollzip = function(options){
        var settings = jQuery.extend({
            showFunction    : null,
            hideFunction    : null,
            showShift       : 0,
            wholeVisible    : false,
            hideShift       : 0,
        }, options);
        return this.each(function(i,obj){
            jQuery(this).addClass('scrollzip');
            if ( jQuery.isFunction( settings.showFunction ) ){
                if(
                    !jQuery(this).hasClass('isShown')&&
                    (jQuery(window).outerHeight()+jQuery('#scrollzipPoint').offset().top-settings.showShift)>(jQuery(this).offset().top+((settings.wholeVisible)?jQuery(this).outerHeight():0))&&
                    (jQuery('#scrollzipPoint').offset().top+((settings.wholeVisible)?jQuery(this).outerHeight():0))<(jQuery(this).outerHeight()+jQuery(this).offset().top-settings.showShift)
                ){
                    jQuery(this).addClass('isShown');
                    settings.showFunction.call( this );
                }
            }
            if ( jQuery.isFunction( settings.hideFunction ) ){
                if(
                    jQuery(this).hasClass('isShown')&&
                    ((jQuery(window).outerHeight()+jQuery('#scrollzipPoint').offset().top-settings.hideShift)<(jQuery(this).offset().top+((settings.wholeVisible)?jQuery(this).outerHeight():0))||
                    (jQuery('#scrollzipPoint').offset().top+((settings.wholeVisible)?jQuery(this).outerHeight():0))>(jQuery(this).outerHeight()+jQuery(this).offset().top-settings.hideShift))
                ){
                    jQuery(this).removeClass('isShown');
                    settings.hideFunction.call( this );
                }
            }
            return this;
        });
    };
    function numberRoller(slno){
            var min=jQuery('.roller-title-number-'+slno).attr('data-min');
            var max=jQuery('.roller-title-number-'+slno).attr('data-max');
            var timediff=jQuery('.roller-title-number-'+slno).attr('data-delay');
            var increment=jQuery('.roller-title-number-'+slno).attr('data-increment');
            var numdiff=max-min;
            var timeout=(timediff*1000)/numdiff;
            //if(numinc<10){
                //increment=Math.floor((timediff*1000)/10);
            //}//alert(increment);
            numberRoll(slno,min,max,increment,timeout);
            
    }
    function numberRoll(slno,min,max,increment,timeout){//alert(slno+"="+min+"="+max+"="+increment+"="+timeout);
        if(min<=max){
            jQuery('.roller-title-number-'+slno).html(min);
            min=parseInt(min)+parseInt(increment);
            setTimeout(function(){numberRoll(eval(slno),eval(min),eval(max),eval(increment),eval(timeout))},timeout);
        }else{
            jQuery('.roller-title-number-'+slno).html(max);
        }
    }
});